import React from 'react';
import vk from '../../images/vk.png';
import rutube from '../../images/rutube.png';

const SocialIcon = ({ id, className, imgClassName }) => {
    switch (id) {
        case 'vk':
            return <img src={vk} alt="" className={imgClassName || className} />;
        case 'telegram':
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    width="25"
                    height="20"
                    viewBox="0 0 25 20"
                    fill="none"
                    aria-hidden
                >
                    <path
                        d="M9.82903 13.1093L9.42121 18.7414C9.59341 18.7587 9.9976 18.7414 10.2369 18.5337C10.4761 18.3261 12.4028 16.5266 13.3363 15.6528C14.8407 16.7256 18.0778 19.0268 18.9913 19.6497C20.1332 20.4284 20.8945 19.8055 21.1664 18.7933C21.4382 17.781 25.027 2.15659 24.9998 1.09247C24.9727 0.0283459 24.1026 -0.179288 23.2326 0.132163C22.3626 0.443614 2.16207 7.86653 1.2105 8.22989C0.258922 8.59325 0.0686011 8.98256 0.0142255 9.11233C-0.0401502 9.2421 0.0414133 9.65737 0.612358 9.89096C1.06911 10.0778 4.7721 11.1627 6.56649 11.6818C10.1734 9.51895 17.5177 5.11538 18.0398 4.80393C18.6923 4.41461 19.8613 3.66195 20.1604 3.55813C20.4595 3.45431 21.0032 3.58409 20.5682 3.94745C20.2202 4.23813 13.2638 10.1765 9.82903 13.1093Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case 'tiktok':
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden
                >
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                </svg>
            );
        case 'youtube':
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden
                >
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                </svg>
            );
        case 'instagram':
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden
                >
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
            );
        case 'dzen':
            return <img src={rutube} alt="" className={imgClassName || className} />;
        default:
            return null;
    }
};

export default SocialIcon;
